import * as utils from '../js/utils';
import * as api from '../js/api';

function redirectTo(props: {redirect_to: string}) {
    if (props.redirect_to) {
        if (props.redirect_to.startsWith('//')) {
            props.redirect_to = window.location.protocol + props.redirect_to;
        }
        return props.redirect_to;
    }
    const url = new URL(window.location.href);
    url.searchParams.set('checkemail', 'registered');
    url.searchParams.delete('action');
    return url.href;
}

async function handleSubmit(event: Event) {
    event.preventDefault();

    const form = event.target as HTMLFormElement;
    const email = form.querySelector('input[name="user_email"]') as HTMLInputElement;
    if (email && !email.value) {
        utils.showMessage({form, message: 'Please enter a valid email.'});
        return;
    }

    utils.setLoading({form: event.target, isLoading: true});

    const body = utils.formData({form});
    try {
        await api.post('/register', body);
        window.location.href = redirectTo({redirect_to: body.redirect_to});
    } catch( e ) {
        utils.showMessage( {form, message: utils.getErrorMessage(e) } );
    }

    utils.setLoading({form: event.target, isLoading: false});
}

export default function () {
    document.querySelectorAll('.payments-register-form').forEach((element) => {
        element.addEventListener('submit', handleSubmit);
    });
}